import URI from "urijs";

const buildURL = {
  install(Vue) {
    if (this.installed) return;

    this.installed = true;

    const prepareUrl = (uri, options) => {
      options = options || {};

      return uri.replace(/\{([^\}]+)\}/g, function (match, pattern) {
        return _.get(options, pattern.trim(), match);
      });
    };

    const buildUrl = (uri, options) => {
      return URI(prepareUrl(uri, options)).normalize().toString();
    };

    const appUrl = (uri, options) => {
      return URI("/app/" + prepareUrl(uri, options))
        .normalize()
        .toString();
    };

    const apiUrl = (uri, options) => {
      return URI("/app/api/" + prepareUrl(uri, options))
        .normalize()
        .toString();
    };

    const toAbsolute = (uri) => {
      return URI(uri).absoluteTo(window.location).toString();
    };

    Vue.prototype["$buildUrl"] = buildUrl;
    Vue["buildUrl"] = buildUrl;

    Vue.prototype["$appUrl"] = appUrl;
    Vue["appUrl"] = appUrl;

    Vue.prototype["$apiUrl"] = apiUrl;
    Vue["apiUrl"] = apiUrl;

    Vue.prototype["$toAbsolute"] = toAbsolute;
    Vue["toAbsolute"] = toAbsolute;
  },
};

export default buildURL;
